import type { HeaderItem } from "@components/common/Header/interface";
import { useAuth } from "@services/authentication/auth.context";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const useGetMenuLayout = () => {

    const location = useLocation();

    const { user } = useAuth();

    if(!user) {
        return [];
    }

    const headerItems: HeaderItem[] = useMemo(() => [
       
        
    ].filter((item: any) => !item.hidden), [user?.role, location.pathname]); // Filter out hidden items

    return headerItems;

}

export default useGetMenuLayout;